import React from 'react';
import Footer from '../../../Shared/Footer/Footer';
import Mainmenu from '../../../Shared/Mainmenu/Mainmenu';
import ViewProjectContent from '../ViewProjectContent/ViewProjectContent';

const ViewProject = () => {
    return (
        <div>
            <Mainmenu/>
            <ViewProjectContent/>
            <Footer/>
        </div>
    );
};

export default ViewProject;